/**
 * CheckboxSwingSelector Component
 * Wrapper combining SwingThumbnail + checkbox logic
 */

import { SwingThumbnail } from './SwingThumbnail';

interface CheckboxSwingSelectorProps {
  id: string;
  thumbnailUrl?: string | null;
  filename?: string | null;
  hasAnalysis: boolean;
  selected: boolean;
  onToggle: (id: string) => void;
  disabled?: boolean;
}

export function CheckboxSwingSelector({
  id,
  thumbnailUrl,
  filename,
  hasAnalysis,
  selected,
  onToggle,
  disabled = false
}: CheckboxSwingSelectorProps) {
  const handleClick = () => {
    if (!disabled) {
      onToggle(id);
    }
  };

  return (
    <SwingThumbnail
      id={id}
      thumbnailUrl={thumbnailUrl}
      filename={filename}
      selected={selected}
      hasAnalysis={hasAnalysis}
      onClick={handleClick}
      className={disabled ? 'opacity-50 cursor-not-allowed' : ''}
    />
  );
}


